import React from 'react';
import type { PortvilleApplicationFilterKey } from '../../../../utils/portvilleApplicationStatus';

interface ApplicationFilterProps {
  currentFilter: PortvilleApplicationFilterKey;
  onFilterChange: (filter: PortvilleApplicationFilterKey) => void;
}

const filters: Array<{
  key: PortvilleApplicationFilterKey;
  label: string;
  activeClassName: string;
}> = [
  { key: 'all', label: '전체', activeClassName: 'bg-blue-500 text-white' },
  { key: 'pending', label: '대기중', activeClassName: 'bg-yellow-500 text-white' },
  { key: 'checked', label: '검토완료', activeClassName: 'bg-blue-500 text-white' },
  { key: 'approved', label: '입주진행', activeClassName: 'bg-green-500 text-white' },
  { key: 'application_cancelled', label: '신청취소', activeClassName: 'bg-red-500 text-white' },
  { key: 'occupancy_cancelled', label: '입주취소', activeClassName: 'bg-red-700 text-white' },
  { key: 'contracted', label: '계약완료', activeClassName: 'bg-indigo-600 text-white' },
  { key: 'completed', label: '처리완료', activeClassName: 'bg-gray-700 text-white' },
];

const ApplicationFilter: React.FC<ApplicationFilterProps> = ({
  currentFilter,
  onFilterChange,
}) => {
  return (
    <div className="mb-6">
      <div className="flex flex-wrap gap-2">
        {filters.map((filter) => (
          <button
            key={filter.key}
            onClick={() => onFilterChange(filter.key)}
            className={`px-4 py-2 rounded-md ${
              currentFilter === filter.key
                ? filter.activeClassName
                : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
            }`}
          >
            {filter.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default ApplicationFilter; 
